import axios from "axios";
import React, { useContext, useEffect, useState } from "react";

const ArticleContext = React.createContext();

export const ArticleProvider = ({ children }) => {

  // Buat state yang diperlukan untuk menampung data fetching

  const [articles, setArticles] = useState ([]);
  const [loading, setLoading] = useState(false);
  const [selectedArticle, setSelectedArticle] = useState(null);

  // Fungsi untuk melakukan fetch data

//   const fetchArticles = async () => {
//     setLoading(true);
//     try {
//       const response = await axios.get(
//   `${process.env.REACT_APP_API_URL}/api/articles?ts=${Date.now()}`
// );
//       setArticles(response.data.data);
//     } catch (err) {
//       console.log(err);
//     } finally {
//       setLoading(false);
//     }
//   };

const fetchArticles = async () => {
  setLoading(true);
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/articles?ts=${Date.now()}`
    );
    console.log("API response for articles:", response.data); // 👈 add this
    setArticles(response.data.data);
  } catch (err) {
    console.log(err);
  } finally {
    setLoading(false);
  }
};

  const fetchArticleById = async (id) => {
    setLoading(true);
    try {
    const response = await axios.get(
  `${process.env.REACT_APP_API_URL}/api/articles/${id}?ts=${Date.now()}`
);
      setSelectedArticle(response.data.data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
      fetchArticles();
    }, []);

    console.log("articles", articles);

  return (
    <ArticleContext.Provider value={{articles, loading, selectedArticle, fetchArticles, fetchArticleById}}>{children}</ArticleContext.Provider>
  );
};
// make sure use
export const useArticleContext = () => {
  return useContext(ArticleContext);
};
